const ITEMS = [
  "AGRICULTURE",
  "DEFENCE",
  "INFRASTRUCTURE",
  "MINING",
  "DISASTER MANAGEMENT",
  "ENTERPRISE",
  "DRONE MANUFACTURING",
  "DRONE-AS-A-SERVICE",
  "PILOT TRAINING",
];

function Row({ ariaHidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
      {ITEMS.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 font-display text-2xl md:text-4xl font-bold tracking-tight ${
              i % 2 === 0 ? "text-outline" : "text-[#F9FAFB]"
            }`}
          >
            {item}
          </span>
          <svg viewBox="0 0 24 24" className="h-3 w-3 text-kinetic" fill="currentColor">
            <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6L12 0z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-surface py-6">
      <div className="marquee-track flex">
        <Row />
        <Row ariaHidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-void to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-void to-transparent" />
    </div>
  );
}
